export const reservasPanels = {
  // OtaMessages.vue
  ota: {
    appTitle: "Ativar mensagens de OTA",
    installIntro:
      "Para responder aos seus hóspedes do Booking.com / Airbnb pelo WA Checkin, você precisa instalar o",
    installIntroTail: "app na acomodação.",
    installBtn: "Instalar mensagens de OTA",
    installing: "Instalando o módulo de mensagens…",
    retryLink: "Já instalei o app, verificar novamente",
    loading: "Carregando mensagens de OTA…",
    empty: "Nenhuma mensagem de OTA para esta reserva.",
    modeAi: "IA",
    modeManual: "Manual",
    predefinedHeader: "Respostas rápidas",
    predefinedEmpty: "Nenhuma resposta correspondente.",
    inputPlaceholder: "Digite uma mensagem ou use / para respostas rápidas...",
    attachTitle: "Anexar imagem",
    senderGuest: "Hóspede",
    senderProperty: "Acomodação",
    senderSystem: "Sistema",
    senderUnknown: "Desconhecido",
    fileFallback: "arquivo",
    toastTitle: "Mensagens de OTA",
    errorTitle: "Erro",
    loadError: "Não foi possível carregar as mensagens de OTA.",
    modeErrorDetail: "Não foi possível identificar o chat da OTA. Tente recarregar a página.",
    modeManualOnTitle: "Modo manual ativado",
    modeAiOnTitle: "Agente de IA ativado",
    modeManualOnDetail: "Você responderá às mensagens manualmente",
    modeAiOnDetail: "O bot responderá automaticamente",
    modeChangeError: "Não foi possível alterar o modo do chat da OTA",
    sendError: "Não foi possível enviar a mensagem de OTA.",
    onlyImagesTitle: "Somente imagens",
    onlyImagesDetail: "As OTAs permitem enviar apenas imagens.",
    imageTooBigTitle: "Imagem muito grande",
    imageTooBigDetail: "A imagem não pode ter mais de 5 MB.",
    installNoProperty: "Nenhuma propriedade conectada ao Channex foi encontrada.",
    installOk: "Aplicativo instalado com sucesso.",
    installError: "Não foi possível instalar o aplicativo.",
  },

  // ReservationNotes.vue
  notes: {
    composerPlaceholder: "Escreva uma nota interna…",
    saveHint: "⌘ / Ctrl + Enter para salvar",
    saving: "Salvando…",
    addNote: "Adicionar nota",
    loading: "Carregando notas…",
    emptyTitle: "Nenhuma nota ainda",
    emptyText: "Adicione a primeira nota interna na caixa acima.",
    cancel: "Cancelar",
    save: "Salvar",
    team: "Equipe",
    confirmDelete: "Excluir?",
    yes: "Sim",
    no: "Não",
    editTitle: "Editar",
    deleteTitle: "Excluir",
    loadError: "Não foi possível carregar as notas",
    added: "Nota adicionada",
    saveError: "Não foi possível salvar a nota",
    updated: "Nota atualizada",
    updateError: "Não foi possível atualizar a nota",
    deleted: "Nota excluída",
    deleteError: "Não foi possível excluir a nota",
  },

  // ReservationPaymentsPanel.vue
  payments: {
    pendingLabel: "Pendente",
    paidLabel: "Recebido",
    totalLabel: "Total",
    loading: "Carregando pagamentos…",
    empty: "Nenhum pagamento foi registrado ainda.",
    addPayment: "Adicionar pagamento…",
    fullyPaid: "Reserva totalmente paga",
    recalcTitle: "Recalcular",
    sendWhatsappTitle: "Enviar pelo WhatsApp",
    copyLinkTitle: "Copiar link",
    editAction: "Editar",
    deleteAction: "Excluir",
    modalEditTitle: "Editar pagamento",
    modalAddTitle: "Adicionar pagamento",
    amountLabel: "Valor a cobrar",
    fillRemaining: "Cobrar o restante ({amount})",
    methodLabel: "Forma de pagamento",
    sendWhatsappCheck: "Enviar o link ao hóspede pelo WhatsApp",
    noteLabel: "Nota (opcional)",
    notePlaceholder: "Ex.: depósito, pagar na chegada…",
    cancel: "Cancelar",
    save: "Salvar",
    generateLink: "Gerar link",
    registerPayment: "Registrar pagamento",
    deleteConfirmTitle: "Excluir este pagamento?",
    deleteText1: "Isto excluirá o pagamento de",
    deleteLinkVoided: "O link de pagamento será anulado.",
    deleteIrreversible: "Esta ação não pode ser desfeita.",
    deleteBtn: "Excluir pagamento",
    sendConfirmTitle: "Enviar o link de pagamento?",
    sendText1: "Será enviado ao hóspede o link para pagar pelo WhatsApp o valor de",
    sendBtn: "Enviar link",
    methodCash: "Dinheiro",
    methodCard: "Cartão / maquininha",
    methodTransfer: "Transferência bancária",
    methodOta: "Pago via OTA",
    statusPaid: "Recebido",
    statusPending: "Pendente",
    statusFailed: "Falhou",
    statusCancelled: "Cancelado",
    loadError: "Não foi possível carregar os pagamentos.",
    amountRequired: "Informe um valor.",
    saveError: "Não foi possível salvar o pagamento.",
    deleteError: "Não foi possível excluir.",
    sendLinkError: "Não foi possível enviar o link.",
    recalcError: "Não foi possível recalcular.",
  },

  // RoomAssignmentPanel.vue
  roomAssign: {
    title: "Atribuir quarto",
    subWithUnitPre: "Esta reserva para",
    subWithUnitPost: "ainda não tem um quarto físico atribuído.",
    subNoUnit: "Esta reserva ainda não tem um quarto físico atribuído.",
    loading: "Verificando disponibilidade…",
    freePre: "Quartos disponíveis para",
    freePost: "Escolha um e atribua diretamente:",
    freeBadge: "Livre",
    assigning: "Atribuindo…",
    occupiedNote:
      "{count} quarto ocupado nestas datas | {count} quartos ocupados nestas datas",
    noneFreeTitle: "Não há quartos livres para estas datas.",
    noFreePre: "Todos os quartos em",
    thisType: "este tipo",
    noFreeMid:
      "estão ocupados ou bloqueados em {date}. Para atribuir esta reserva,",
    reorganizeBold: "reorganize as reservas",
    noFreeMid2: "para este tipo de quarto pelo calendário (o botão",
    organizeBtn: "Organizar",
    noFreeTail: ") para liberar um.",
    tagMaintenance: "Manutenção",
    tagBlocked: "Bloqueado",
    theseDates: "estas datas",
    occupied: "Ocupado",
    assignedOk: "Quarto {label} atribuído com sucesso.",
    assignError: "Não foi possível atribuir o quarto.",
    notifyError: "Erro",
    notifyDone: "Concluído",
  },

  // GroupRoomsPanel.vue
  groupRooms: {
    heading: "Quartos nesta reserva",
    typesCount: "{count} tipo | {count} tipos",
    roomsCount: "{count} quarto | {count} quartos",
    guestsCount: "{count} hóspede | {count} hóspedes",
    totalLabel: "Total",
    viewingBadge: "Visualizando",
    noRoomAssigned: "Nenhum quarto atribuído",
    removeOneRoom: "Remover um quarto",
    addOneRoom: "Adicionar um quarto",
    confirmRemove: "Remover?",
    yes: "Sim",
    no: "Não",
    cannotRemoveOnly: "Você não pode remover o único quarto",
    removeRoomFromBooking: "Remover este quarto da reserva",
    updating: "Atualizando…",
    theChannel: "o canal",
    otaManaged:
      "Este quarto é gerenciado por {channel}: quantidade e preço são alterados lá.",
    notifyError: "Erro",
    notifyDone: "Concluído",
    qtyUpdated: "Quantidade atualizada",
    roomRemoved: "Quarto removido da reserva",
    updateError: "Não foi possível atualizar a reserva. Tente novamente.",
  },
};
